export const ML_STATIC_URL = 'https://http2.mlstatic.com';
export const LOGOS_API_ADMIN_BASE_URL = `${ML_STATIC_URL}/storage/logos-api-admin`;

export const ICON_UI_TYPE = {
  MERCADO_PAGO_BLACK: 'icon_mercado_pago_black',
  MERCADO_PAGO: 'icon_account_money',
  ACCOUNT_MONEY_YELLOW: 'icon_account_money_yellow',
  CREDITS_YELLOW: 'icon_mercado_credito_yellow',
}
